import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/page/Home.vue';
 
Vue.use(Router);
 
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    // 其他路由配置...
  ]
});
 
// 全局路由守卫
router.beforeEach((to, from, next) => {
  // 如果路径不存在，则重定向到首页
  if (from.name !== null && !router.getRoutes().some(route => route.name === to.name)) {
    return next({ name: 'home' });
  }
  next();
});
 
export default router;